module.exports = __webpack_public_path__ + "img/assetToken.4fe0a7f4.png";